import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";

import commonEn from "./locales/en/common.json";
import commonDe from "./locales/de/common.json";
import userEn from "./locales/en/user.json";
import userDe from "./locales/de/user.json";
import dashboardEn from "./locales/en/dashboard.json";
import dashboardDe from "./locales/de/dashboard.json";
import incidentsEn from "./locales/en/incidents.json";
import incidentsDe from "./locales/de/incidents.json";
import membersEn from "./locales/en/members.json";
import membersDe from "./locales/de/members.json";
import workspacesEn from "./locales/en/workspaces.json";
import workspacesDe from "./locales/de/workspaces.json";
import monitorsEn from "./locales/en/monitors.json";
import monitorsDe from "./locales/de/monitors.json";
import statusPagesEn from "./locales/en/status_pages.json";
import statusPagesDe from "./locales/de/status_pages.json";
import onCallEn from "./locales/en/on_call.json";
import onCallDe from "./locales/de/on_call.json";
import channelsEn from "./locales/en/channels.json";
import channelsDe from "./locales/de/channels.json";
import groupsEn from "./locales/en/groups.json";
import groupsDe from "./locales/de/groups.json";
import maintenanceEn from "./locales/en/maintenance.json";
import maintenanceDe from "./locales/de/maintenance.json";
import auditLogEn from "./locales/en/audit_log.json";
import auditLogDe from "./locales/de/audit_log.json";
import settingsEn from "./locales/en/settings.json";
import settingsDe from "./locales/de/settings.json";
import signupEn from "./locales/en/signup.json";
import signupDe from "./locales/de/signup.json";
import loginEn from "./locales/en/login.json";
import loginDe from "./locales/de/login.json";
import authEn from "./locales/en/auth.json";
import authDe from "./locales/de/auth.json";
import monitorDetailEn from "./locales/en/monitor_detail.json";
import monitorDetailDe from "./locales/de/monitor_detail.json";
import groupDetailEn from "./locales/en/group_detail.json";
import groupDetailDe from "./locales/de/group_detail.json";
import workspacePickerEn from "./locales/en/workspace_picker.json";
import workspacePickerDe from "./locales/de/workspace_picker.json";
import aiAssistantEn from "./locales/en/ai_assistant.json";
import aiAssistantDe from "./locales/de/ai_assistant.json";
import alertRulesEn from "./locales/en/alert_rules.json";
import alertRulesDe from "./locales/de/alert_rules.json";
import inboundWebhooksEn from "./locales/en/inbound_webhooks.json";
import sitesEn from "./locales/en/sites.json";
import sitesDe from "./locales/de/sites.json";
import teamsEn from "./locales/en/teams.json";
import teamsDe from "./locales/de/teams.json";
import servicesEn from "./locales/en/services.json";
import servicesDe from "./locales/de/services.json";
import routingRulesEn from "./locales/en/routing_rules.json";
import routingRulesDe from "./locales/de/routing_rules.json";

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      en: {
        common: commonEn,
        user: userEn,
        dashboard: dashboardEn,
        incidents: incidentsEn,
        members: membersEn,
        workspaces: workspacesEn,
        monitors: monitorsEn,
        status_pages: statusPagesEn,
        on_call: onCallEn,
        channels: channelsEn,
        groups: groupsEn,
        maintenance: maintenanceEn,
        audit_log: auditLogEn,
        settings: settingsEn,
        signup: signupEn,
        login: loginEn,
        auth: authEn,
        monitor_detail: monitorDetailEn,
        group_detail: groupDetailEn,
        workspace_picker: workspacePickerEn,
        ai_assistant: aiAssistantEn,
        alert_rules: alertRulesEn,
        inbound_webhooks: inboundWebhooksEn,
        sites: sitesEn,
        teams: teamsEn,
        services: servicesEn,
        routing_rules: routingRulesEn,
      },
      de: {
        common: commonDe,
        user: userDe,
        dashboard: dashboardDe,
        incidents: incidentsDe,
        members: membersDe,
        workspaces: workspacesDe,
        monitors: monitorsDe,
        status_pages: statusPagesDe,
        on_call: onCallDe,
        channels: channelsDe,
        groups: groupsDe,
        maintenance: maintenanceDe,
        audit_log: auditLogDe,
        settings: settingsDe,
        signup: signupDe,
        login: loginDe,
        auth: authDe,
        monitor_detail: monitorDetailDe,
        group_detail: groupDetailDe,
        workspace_picker: workspacePickerDe,
        ai_assistant: aiAssistantDe,
        alert_rules: alertRulesDe,
        inbound_webhooks: inboundWebhooksEn,
        sites: sitesDe,
        teams: teamsDe,
        services: servicesDe,
        routing_rules: routingRulesDe,
      },
    },
    fallbackLng: "en",
    ns: ["common", "user", "dashboard", "incidents", "members", "workspaces", "monitors", "status_pages", "on_call", "channels", "groups", "maintenance", "audit_log", "settings", "signup", "login", "auth", "monitor_detail", "group_detail", "workspace_picker", "ai_assistant", "alert_rules", "inbound_webhooks", "sites", "teams", "services", "routing_rules"],
    defaultNS: "common",
    interpolation: {
      escapeValue: false,
    },
    detection: {
      order: ["querystring", "cookie", "localStorage", "sessionStorage", "navigator", "htmlTag"],
      caches: ["localStorage", "cookie"],
    },
  });

export default i18n;
